module.exports = __webpack_public_path__ + "static/media/person.c6aca1f5.svg";